import { useCreateNumberTypeMutation } from "@/react/features/globalization/globalizationApi";
import { displayToastMessage } from "@/react/notifications";
import {
  CREATE_TEXT_KO,
  CREATE_TEXT_OK,
  TOAST_DURATION,
} from "@/react/features/globalization/constants";
import { TYPE } from "@8x8/oxygen-toaster";

const useCreateNumberType = () => {
  const [createNumberTypes] = useCreateNumberTypeMutation();

  const onCreateNumberType = async (row, field, selectedOption, onUpdate) => {
    try {
      const response = await createNumberTypes({
        name: selectedOption.value,
      }).unwrap();
      await onUpdate(row, "number_type", { id: response.id });
      displayToastMessage(CREATE_TEXT_OK, {
        duration: TOAST_DURATION,
        type: TYPE.info,
      });
    } catch (e) {
      displayToastMessage(CREATE_TEXT_KO, { duration: TOAST_DURATION });
    }
  };

  return [onCreateNumberType];
};

export default useCreateNumberType;
